import React from "react";
import useStyles from "./Styles";
import { MenuItem, TextField } from "@material-ui/core";

const CustomizedSelect = (props) => {
  const classes = useStyles();
  const { label, disabled, options, handleSelectedItem, dropdownValue, type, fullWidth, style } = props;
  return (
    <>
      <TextField
        select
        label={label}
        value={dropdownValue}
        fullWidth={fullWidth}
        style={style}
        variant="outlined"
        onChange={handleSelectedItem}
        InputProps={{
          classes: {
            input:
              type === "location" ? classes.locationFilter : classes.filter,
          },
        }}
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          },
        }}
        disabled={disabled}
      >
        {options.map((option, idx) => (
          <MenuItem
            style = {{fontFamily: "Arial"}}
            key={idx}
            value={option.value}
            classes={{ root: classes.menuItemRoot }}
          >
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

CustomizedSelect.defaultProps = {
  fullWidth: false,
  style: {}
};

export default CustomizedSelect;
